import {Action, getModule, Module, MutationAction, VuexModule} from 'vuex-module-decorators';
import store from '@/store';
import {ResponseDataType} from "@/form/form.types";
import {ICashboxType, CashboxTypeResponseType} from "@/entity/finance/cashbox/cashboxType.types";
import {PaginationRequestType} from "@/entity/common/pagination.types";

@Module({
    namespaced: true,
    name: 'cashboxTypes',
    store,
    dynamic: true,
})
class CashboxTypesModule extends VuexModule {
    items: ICashboxType[] = [];
    itemsLoaded = false;

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ items: ICashboxType[]; itemsLoaded: boolean }> {
        const items = await store.$repository.cashboxTypes.fetchAll(data);
        let itemsLoaded = false;
        if (items.length > 0) {
            itemsLoaded = true;
        }
        return {items, itemsLoaded};
    }
    @Action({rawError: true})
    async delete(id: number): Promise<ResponseDataType> {
        const resp = await store.$repository.cashboxTypes.delete({id: id});
        return resp;
    }
}

export const CashboxTypesStore = getModule(CashboxTypesModule);
